// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607211248/js/" + chunkId + "." + {"44":"0686d3f6","225":"d1336ac7","481":"6fc7bb8c","486":"98a9f13e","770":"e2364c8a"}[chunkId] + ".0.4214284480706557.chunk.js";
};